// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ScenarioStatusSchema = z.enum(['DRAFT','PRECHECK_PASSED','PRECHECK_BLOCKED','RUNNING','COMPLETED','FAILED','STOPPED'] as const);

export type ScenarioStatusType = `${z.infer<typeof ScenarioStatusSchema>}`

export default ScenarioStatusSchema;
